import { PropsWithChildren } from 'react';

import { Grid } from '@mui/material';

function FiltersActionsContainer({ children }: PropsWithChildren) {
  return (
    <Grid sx={{ mb: 2.5 }} container direction="row" justifyContent="flex-end">
      {children}
    </Grid>
  );
}

export default FiltersActionsContainer;
